import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import { times } from 'lodash';

import styles from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');
const US_NUM = 4;
const OTHER_NUM = 5;
const listNum = { us: US_NUM, ca: US_NUM };

const earnMorename = styles.earnMore;
export default function EarnMore() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');
    const { locale } = useRouter();
    const earnMoreList = times(listNum[locale as keyof typeof listNum] || OTHER_NUM, (index) => `earnMore.card${index + 1}_desc`);

    const bgImgMap = { jp: ['earn_more_jp.webp', 'earn_more_jp.png'], kr: ['earn_more_kr.webp', 'earn_more_kr.png'] };
    const bgImg = bgImgMap[locale as keyof typeof bgImgMap] || bgImgMap.jp;

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `.${earnMorename}`,
            offset: 200, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 300,
        });
        const tweenA1 = TweenMax.to(`.${earnMorename} .earn-more`, 0.5, { opacity: 1, rotateX: 0 });
        scene.setTween(tweenA1);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    return (
        <div className={earnMorename}>
            <div className="earn-more">
                <EFPic className="earn-more__bg" name={bgImg} />
                <div className="earn-more__content">
                    <div className="earn-more__title">{t('earnMore.title')}</div>
                    <div className="earn-more__list">
                        {earnMoreList.map((langKey: string, index) => (
                            <div key={index} className={`earn-more__item earn-more__item${index}`}>
                                <div className={`earn-more__svg earn-more__svg${index}`}></div>
                                <div className="earn-more__text">
                                    {t.rich(langKey, { highLightNum: (text: string) => <span className="red-text">{text}</span> })}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
